import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { UserPlus } from "lucide-react";

export default function TeamTab({ invites, API, authHeaders, onReload }) {
  const sendInvite = async (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    try {
      await axios.post(`${API}/admin/invites`, { email }, { headers: authHeaders() });
      toast.success(`Invite created for ${email}`);
      e.target.reset();
      onReload();
    } catch {
      toast.error("Failed");
    }
  };

  const pending = invites.filter(i => !i.used);

  return (
    <div className="max-w-2xl" data-testid="team-tab">
      <div className="card-industrial p-6 mb-6">
        <h3 className="font-display text-2xl mb-4">INVITE ADMIN</h3>
        <form onSubmit={sendInvite} className="flex gap-2">
          <input required name="email" type="email" placeholder="admin@example.com" className="input-field flex-1" data-testid="invite-email"/>
          <button className="btn-primary inline-flex items-center gap-2" data-testid="send-invite-btn"><UserPlus size={16}/> INVITE</button>
        </form>
        <p className="font-mono text-xs mt-3 text-[var(--ink-2)]">When they sign up with this email, they'll automatically become an admin.</p>
      </div>
      <div className="card-industrial p-6">
        <h3 className="font-display text-xl mb-3">PENDING INVITES</h3>
        {pending.map(i => <div key={i.email} className="font-mono text-sm py-1 border-b border-[var(--muted)]">{i.email}</div>)}
        {pending.length === 0 && <div className="font-mono text-xs">No pending invites.</div>}
      </div>
    </div>
  );
}
